import { Button } from 'components/atoms/Button'
import { Modal, StatusModal } from 'components/organisms/Modals'
import { APYCalculationMethodForm, ApyCalculationMethodSchema } from 'components/Portfolios/APYManualForm'
import styled from 'styled-components'
import { EditIcon } from 'components/atoms/Icons/IconsFiles/EditIcon'
import { useSaveOfferingApyCalculationMethod } from './useSaveOfferingApyCalculationMethod'
import { ArrowForwardIcon } from 'components/atoms/Icons'
import { useState } from 'react'
import { useRouter } from 'next/router'
import { LiveDataOffering } from 'types'
import { isAssetOffering } from 'types/Portfolio/StructuredOffering'
import { APYCalculationMethod } from 'types/Portfolio/APYCalculation'

interface Props {
  offering: LiveDataOffering
}

export const APYCalculationMethodModal = ({ offering }: Props) => {
  const [isAPYModalOpen, setIsAPYModalOpen] = useState<boolean>(false)
  const { mutateAsync: save, reset, isSuccess, isError } = useSaveOfferingApyCalculationMethod(offering.id)
  const router = useRouter()

  const liveValue = isAssetOffering(offering) ? offering.currentApyInBPS : 0

  const manualValues = offering.manualAPYOverride
    ? {
        value: offering.manualAPYOverride.value,
        longDescription: offering.manualAPYOverride.description ?? undefined,
        name: offering.manualAPYOverride.name,
      }
    : undefined

  const refreshData = () => router.push(router.asPath, undefined, { unstable_skipClientCache: true })
  const submit = async (method: APYCalculationMethod, manualAPYOverride: ApyCalculationMethodSchema | null) => {
    await save({
      method,
      manualAPYOverride: manualAPYOverride
        ? {
            ...manualAPYOverride,
            description: manualAPYOverride?.longDescription,
          }
        : null,
    })
    setIsAPYModalOpen(false)
    await refreshData()
  }

  const showStatusModal = isSuccess || isError

  return (
    <>
      <EditButton icon={<EditIcon />} onClick={() => setIsAPYModalOpen((isOpen) => !isOpen)} />
      {isAPYModalOpen && (
        <Modal
          title="Edit"
          opened={isAPYModalOpen}
          toggleOpened={setIsAPYModalOpen}
          content={
            <APYCalculationMethodForm
              currentMethod={offering.apyCalculationMethod}
              manualValues={manualValues}
              liveValue={liveValue}
              onSubmit={submit}
            />
          }
        />
      )}
      {showStatusModal && (
        <StatusModal
          onClose={reset}
          state={isSuccess ? 'Success' : 'Fail'}
          message={isSuccess ? 'APY calculation method saved' : 'Operation failed'}
        >
          {isSuccess && (
            <Button onClick={reset} view="tertiary" icon={<ArrowForwardIcon />} iconPosition="right">
              Close
            </Button>
          )}
        </StatusModal>
      )}
    </>
  )
}

const EditButton = styled(Button)`
  border: 1px solid ${({ theme }) => theme.colors.HeavyMetal};
  width: 24px;
  min-width: 24px;
  height: 24px;
  min-height: 24px;
  padding: 0;
`
